/**
 * Export component file to be used on project
 */

import { Column } from './Column';
export default Column;